// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Service
import BreedService from "@/app/services/main/breeds/breeds-service"

// Constants
import { STATUS_CODES } from "@/app/constants/constants"

export default {
	name: "BreedTableComponent",
	mixins: [tableMixins, toastMessageMixins],
	props: {
		applicableBreeds: {
			type: Array,
			default: null,
		},
		selectedSize: {
			default: "",
		},
	},
	data() {
		return {
			isBreedsAPILoading: false,
			hasBreedListChanges: false,
			initialLoad: true,
			// table
			theads: [
				{
					name: "Breeds",
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					style: "width: 90%",
				},
				{
					name: null,
					searchLabel: null,
					sortLabel: null,
					isDesc: false,
					hasSearch: false,
					hasToggle: true,
					style: "width: 10%",
				},
			],
			headerToggleCheckbox: false,
			filterQuery: "",
			filteredResults: [],
		}
	},
	mounted: function() {
        if (this.selectedSize) {
            this.getBreedsList(this.selectedSize)
        }
    },
	watch: {
		tableContent(newTable) {
			return newTable
		},
		selectedSize(newSize) {
			if (newSize) {
				this.getBreedsList(newSize)
			}
		},
		filterQuery(newQuery) {
			if (newQuery.length > 0) {
				this.filterBreedList(newQuery)
			} else {
				this.filteredResults = []
			}
			return newQuery
		},
	},
	methods: {
		filterBreedList(value) {
			const results = []
			this.tableContent.tableData.find((o, i) => {
				if (o.name.toLowerCase().includes(value.toLowerCase())) {
					results.push(o)
				}
			})
			this.filteredResults = results
		},
		getBreedsList(breedSizeId) {
			this.isBreedsAPILoading = true

			BreedService.getBreedsBySize(breedSizeId)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						let countInActive = 0
						let parsedBreeds = res.data.data
							.map((breed) => {
								if (breed.id !== 0) {
									return {
										...breed,
										status: "A",
									}
								}
							})
							.filter((data) => data)

						const range = this.selectedSize === 2 ? 2 : 1
						// Should only happen in initial load.
						if (this.applicableBreeds && this.initialLoad) {
							// Remove reactivity
							let updatedList = JSON.parse(JSON.stringify(this.applicableBreeds))

							for (const i in parsedBreeds) {
								const parsedBreed = parsedBreeds[i]
								// check if parsed Breed from API exists in Edit Product Breed List
								if (!this.applicableBreeds.find((data) => data.id === parsedBreed.id)) {
									updatedList.push(parsedBreed)
								}
							}

							const otherBreedOptions = updatedList.slice(0, range)
							updatedList = this.sortAlphabetically(updatedList.slice(range, updatedList.count))
							updatedList = [...otherBreedOptions, ...updatedList]
							this.tableContent.tableData = updatedList
						} else {
							// breedSize is selected to ALL
							if ( breedSizeId != 6 ) {
								const otherBreedOptions = parsedBreeds.slice(0, range)
								parsedBreeds = this.sortAlphabetically(parsedBreeds.slice(range, parsedBreeds.count))
								parsedBreeds = [...otherBreedOptions, ...parsedBreeds]
							}
							this.tableContent.tableData = parsedBreeds
						}
						// removed Breed not specify
						this.tableContent.tableData = this.tableContent.tableData.filter((breed) => {
							if (breed.id !== 0) {
								return {
									...breed,
								}
							}
						})

						this.tableContent.tableData.map((breed) => {
							if (breed.status === "I") {
								countInActive++
							}
						})
									
						if (countInActive === 0) {
							this.headerToggleCheckbox = true
						}  else {
							this.headerToggleCheckbox = false
						}

						this.updateBreedList()
						this.initialLoad = false
					} else {
						this.showAPIErrorToast(this.toastMessages.breed().ERROR_GET_BREED_TITLE, res)
					}

					this.isBreedsAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isBreedsAPILoading = false
				})
		},
		updateBreedList() {
			const content = this.tableContent.tableData
			this.$emit("updateBreedList", content)
		},
		updateBreedListFlag() {
			this.$emit("hasBreedListChanges", this.hasBreedListChanges)
		},
		toggleApplicableBreed(event, breed) {
			let flag = event.target.checked
			
			//headerToggleCheckbox
			if (!flag) {
				this.headerToggleCheckbox = false
			}

			this.mutateBreedTable(flag, breed)
		},
		mutateBreedTable(flag, selectedBreed) {
			let existingData = null
			let countInActive = 0

			if (this.applicableBreeds) {
				const editProductBreedList = JSON.parse(JSON.stringify(this.applicableBreeds))
				existingData = editProductBreedList.find((data) => data.id === selectedBreed.id)
			}

			this.tableContent.tableData = this.tableContent.tableData.map((breed) => {
				if (breed.id === selectedBreed.id) {
					breed.status = flag ? "A" : "I"

					if (existingData) {
						this.hasBreedListChanges = existingData.status !== breed.status
					} else {
						this.hasBreedListChanges = true
					}
				}

				return breed
			})

			this.tableContent.tableData.map((breed) => {
				if (breed.status === "I") {
					countInActive++
				}
			})

			if (countInActive === 0) {
				this.headerToggleCheckbox = true
			} else {
				this.headerToggleCheckbox = false
			}	

			this.updateBreedListFlag()
			this.updateBreedList()
		},
		toggleSelectDeselect(event) {
			let flag = event.target.checked
			let existingData = null
			let hasChange = 0

			if (this.applicableBreeds) {
				existingData = JSON.parse(JSON.stringify(this.applicableBreeds))
			}
			this.tableContent.tableData = this.tableContent.tableData.map((breed) => {
				breed.status = flag ? "A" : "I"

				if (existingData && existingData.length > 0) {
					const existingBreed = existingData.find((data) => data.id === breed.id)
					if(existingBreed.status !== breed.status) {
						hasChange ++
					}	
				} else {
					hasChange ++
				}

				return breed
			})

			this.hasBreedListChanges = hasChange > 0
			
			//headerToggleCheckbox
			// if (!flag) {
			// 	this.headerToggleCheckbox = false
			// }

			this.headerToggleCheckbox = flag

			this.updateBreedListFlag()
		},
		sortAlphabetically(items) {
			const sortedItems = items.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			return sortedItems
		},
	},
}
